import { createUseStyles, Platform } from 'core/src';
import {
  Avatar,
  Line,
  MyTextInput,
  Spacing,
  Typography,
} from 'components/src/atoms';
import React, { useEffect, useState } from 'react';
import {
  Modal,
  View,
  TouchableOpacity,
  FlatList,
  TouchableWithoutFeedback,
} from 'react-native';
import { useTranslation } from 'react-i18next';
import MaterialIcons from 'react-native-vector-icons/MaterialIcons';

const MaterialIconsX = MaterialIcons as unknown as React.ComponentType<any>;

interface CustomModalProps {
  visible: boolean;
  onClose: () => void;
  users: any;
  isTag: boolean;
  onConfirm: (selectedUsers: any) => void;
}

const CustomModal: React.FC<CustomModalProps> = ({
  visible,
  onClose,
  users,
  onConfirm,
  isTag,
}) => {
  const { styles, colors } = useStyles();
  const [selectedUsers, setSelectedUsers] = useState<any>([]);
  const [filterUser, setFilterUser] = useState<any>(users);

  useEffect(() => {
    !isTag && setSelectedUsers([]);
  }, [isTag]);
  const { i18n } = useTranslation();
  const toggleSelection = (user: any) => {
    let updatedUsers;
    if (selectedUsers.includes(user)) {
      updatedUsers = selectedUsers.filter((item: any) => item !== user);
    } else {
      updatedUsers = [...selectedUsers, user];
    }
    setSelectedUsers(updatedUsers);
    onConfirm(updatedUsers);
  };
  return (
    <Modal visible={visible} transparent animationType="fade">
      <TouchableWithoutFeedback onPress={onClose}>
        <View style={styles.modalContainer}>
          <TouchableWithoutFeedback>
            <View style={styles.modalContent}>
              <View
                style={{
                  margin: 20,
                  backgroundColor: colors.bioInput,
                  borderRadius: 7,
                }}
              >
                <MyTextInput
                  inputWidth={'100%'}
                  change={(text) => {
                    const filteredUsers = users?.filter((item: any) =>
                      item?.name_and_family?.includes(text),
                    );
                    setFilterUser(
                      filteredUsers.map((item: any) => {
                        return item;
                      }),
                    );
                  }}
                  classes={styles.search}
                  inlineImageLeft={
                    <MaterialIconsX
                      name="search"
                      size={25}
                      color={colors.secondryColor}
                    />
                  }
                  placeholder={i18n.t('enterName') + '...'}
                />
              </View>
              <FlatList
                data={filterUser}
                keyExtractor={(item) => item}
                showsVerticalScrollIndicator={false}
                renderItem={({ item }) => (
                  <TouchableOpacity
                    style={styles.item}
                    onPress={() => toggleSelection(item.user_name)}
                  >
                    <View style={{ flexDirection: 'row' }}>
                      <Avatar
                        openImage={false}
                        radius={60}
                        size={50}
                        source={item.avatar}
                      />
                      <Typography
                        text={
                          item.name_and_family?.length > 15
                            ? item.name_and_family?.substring(0, 15) + '...'
                            : item.name_and_family
                        }
                        classes={
                          selectedUsers.includes(item.user_name)
                            ? styles.selectedText
                            : styles.text
                        }
                      />
                    </View>
                    <Spacing vertical={5} />
                    <Line />
                  </TouchableOpacity>
                )}
              />
            </View>
          </TouchableWithoutFeedback>
        </View>
      </TouchableWithoutFeedback>
    </Modal>
  );
};

const useStyles = createUseStyles(({ colors, theme }) => ({
  modalContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: Platform.isDesktop ? 'center' : 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
  modalContent: {
    width: 300,
    backgroundColor: colors.color02,
    borderRadius: 10,
    // padding: 20,
    height: 300,
    margin: 30,
    textAlign: 'center',
  },
  item: {
    padding: 10,
  },
  text: {
    fontSize: 18,
    color: colors.primaryColor,
    padding: 15,
  },
  selectedText: {
    fontSize: 18,
    opacity: 0.3,
    padding: 15,
  },
  search: {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: colors.searchBack,
  },
}));

export default CustomModal;
